import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import ToolTip from "./ToolTip";

export default function Segmented(props) {
  const {
    options = [],
    value = "",
    block = false,
    tooltip_width = 0,
    onChange = () => { },
  } = props;

  const wrapRef = useRef(null);
  const itemRefs = useRef({});
  const [indicator, setIndicator] = useState({ left: 0, width: 0 });
  const [ready, setReady] = useState(false); // 👈 controls animation

useLayoutEffect(() => {
  const update = () => {
    const el = itemRefs.current[value];
    if (!el) return;

    setIndicator({
      left: el.offsetLeft,
      width: el.offsetWidth,
    });
  };

  update();

  const observer = new ResizeObserver(update);
  if (wrapRef.current) observer.observe(wrapRef.current);

  return () => observer.disconnect();
}, [value, options, block]);

  // 👇 enable animation AFTER first layout
  useEffect(() => {
    const id = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(id);
  }, []);

  const move = (dir) => {
    const idx = options.findIndex(o => o.value === value);
    const next = options[(idx + dir + options.length) % options.length];
    onChange(next.value);
  };

  return (
    <div ref={wrapRef} className={`ui-segmented ${block ? "block" : ""}`}  role="tablist">
      <span
        className={`ui-segmented-indicator ${ready ? "ready" : ""}`}
        style={{
          transform: `translateX(${indicator.left}px)`,
          width: `${indicator.width}px`,
        }}
      />


      {options.map((opt, i) => {
        const active = opt.value === value;

        return (
          <ToolTip width={tooltip_width} text={opt?.help || ""} >
            <button
              key={opt.value ?? i}
              ref={(el) => el && (itemRefs.current[opt.value] = el)}
              role="tab"
              className={`ui-segmented-item ${active ? "active" : ""}`}
              onClick={() => onChange(opt.value)}
              tabIndex={active ? 0 : -1}
              onKeyDown={(e) => {
                if (e.key === "ArrowRight") {
                  e.preventDefault();
                  move(1);
                }
                if (e.key === "ArrowLeft") {
                  e.preventDefault();
                  move(-1);
                }
              }}
            >
              {opt.label}
            </button>
          </ToolTip>
        );
      })}
    </div>
  );
}